module.exports = __webpack_public_path__ + "img/turkey-flag.ac5d76dd.svg";